module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/54_Diagonal Market Arrows Sweatpant.png";